"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentsSeriesForm = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var semantic_ui_react_1 = require("semantic-ui-react");
var react_router_1 = require("react-router");
var util_1 = require("../util");
var i18n_1 = __importDefault(require("../i18n"));
var context_1 = require("../context");
var sentry_1 = require("../sentry");
var api_1 = require("../api");
var TwitterWidget_1 = require("./TwitterWidget");
var ContentsSeriesForm = function GroupDetail(_a) {
    var contentsSeries = _a.contentsSeries, contentsItems = _a.contentsItems, loading = _a.loading, setContentsSeriesFetchRequest = _a.setContentsSeriesFetchRequest, setContentsItemsFetchRequest = _a.setContentsItemsFetchRequest, user = _a.user;
    var isNew = !contentsSeries;
    var incrementErrorCount = React.useContext(context_1.IncrementErrorCountContext);
    var _b = React.useState(contentsSeries ? __assign({}, contentsSeries) : { id: "", name: "", userProfileId: user.id }), tempContentsSeries = _b[0], setTempContentsSeries = _b[1];
    var _c = React.useState(contentsSeries ? contentsSeries.id : undefined), id = _c[0], setId = _c[1];
    var _d = React.useState(""), newUrl = _d[0], setNewUrl = _d[1];
    var _e = React.useReducer(function (edits, targetId) {
        var _a;
        return (__assign(__assign({}, edits), (_a = {}, _a[targetId] = !edits[targetId], _a)));
    }, {}), showEdits = _e[0], toggleShowEdits = _e[1];
    var _f = React.useReducer(function (prevContentsItems, addingContentsItem) {
        var _a;
        return addingContentsItem instanceof Array
            ? addingContentsItem.reduce(function (hash, contentsItem) {
                var _a;
                return (__assign(__assign({}, hash), (_a = {}, _a[contentsItem.id] = contentsItem, _a)));
            }, {})
            : __assign(__assign({}, prevContentsItems), (_a = {}, _a[addingContentsItem.id] = addingContentsItem, _a));
    }, {}), tempContentsItems = _f[0], setTempContentsItems = _f[1];
    React.useEffect(function () {
        setTempContentsItems(contentsItems);
    }, [contentsItems]);
    var setProp = genSetTempContentsSeriesProp(setTempContentsSeries);
    var validateResult = validateGroup(tempContentsSeries);
    var ValidationResult = genValidationResult(validateResult);
    var changed = !(0, util_1.isContentsSeriesEqual)(contentsSeries, tempContentsSeries);
    if (id && !contentsSeries)
        return (0, jsx_runtime_1.jsx)(react_router_1.Redirect, { to: "/contents_series/".concat(id) });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Dimmer.Dimmable, { dimmed: loading, children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Dimmer, { active: loading, inverted: true, children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Loader, { children: i18n_1.default.loading }) }), (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Form, { onSubmit: function (e) { return e.preventDefault(); }, children: [(0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Form.Field, { required: true, error: !!validateResult.name, children: [(0, jsx_runtime_1.jsx)("label", { children: i18n_1.default.contentsSeriesName }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Input, { maxLength: "255", defaultValue: tempContentsSeries.name || "", onChange: setProp("name"), placeholder: "comic1" }), (0, jsx_runtime_1.jsx)(ValidationResult, { prop: "name" })] }), (0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Form.Field, { error: !!validateResult.description, children: [(0, jsx_runtime_1.jsx)("label", { children: i18n_1.default.description }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Input, { maxLength: "70", defaultValue: tempContentsSeries.description || "", onChange: setProp("description"), placeholder: "very fun" }), (0, jsx_runtime_1.jsx)(ValidationResult, { prop: "description" })] }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { onClick: function () {
                                    return saveContentsSeries(isNew, tempContentsSeries, setContentsSeriesFetchRequest, setId, incrementErrorCount);
                                }, color: "green", disabled: !validateResult.valid || !changed || loading, children: changed ? (isNew ? i18n_1.default.create : i18n_1.default.update) : i18n_1.default.saved })] })] }), contentsSeries && ((0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Dimmer.Dimmable, { dimmed: loading, children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Dimmer, { active: loading, inverted: true, children: (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Loader, { children: i18n_1.default.loading }) }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Input, { fluid: true, value: newUrl, onChange: function (e, _a) {
                            var value = _a.value;
                            return setNewUrl(value);
                        }, placeholder: "https://twitter.com/example/status/12345678901234567890" }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { color: "blue", onClick: function () {
                            return addContentsItem({
                                id: "",
                                name: "",
                                contentsSeriesId: contentsSeries.id,
                                userProfileId: user.id,
                                content: newUrl,
                                sourcePublishedAt: "",
                            }, setContentsItemsFetchRequest, incrementErrorCount);
                        }, children: i18n_1.default.add }), 
                    // TODO: order
                    contentsItems
                        .sort(function (a, b) { return Number(b.id) - Number(a.id); })
                        .map(function (contentsItem) { return ((0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Segment, { children: [(0, jsx_runtime_1.jsx)(TwitterWidget_1.TwitterWidget, { url: contentsItem.content }, contentsItem.content), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { color: showEdits[contentsItem.id] ? undefined : "green", onClick: function () { return toggleShowEdits(contentsItem.id); }, children: showEdits[contentsItem.id] ? i18n_1.default.cancel : i18n_1.default.edit }), showEdits[contentsItem.id] && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Input, { value: (tempContentsItems[contentsItem.id] || {}).content, onChange: function (e, _a) {
                                            var value = _a.value;
                                            return setTempContentsItems(__assign(__assign({}, contentsItem), { content: value }));
                                        } }), (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { color: "green", disabled: (tempContentsItems[contentsItem.id] || {}).content ===
                                            contentsItem.content, onClick: function () {
                                            return replaceContentsItem(tempContentsItems[contentsItem.id], setContentsItemsFetchRequest, incrementErrorCount);
                                        }, children: i18n_1.default.update })] })), !showEdits[contentsItem.id] && ((0, jsx_runtime_1.jsx)(semantic_ui_react_1.Button, { color: "red", onClick: function () {
                                    return destroyContentsItem(contentsItem.id, setContentsItemsFetchRequest, incrementErrorCount);
                                }, children: i18n_1.default.delete }))] }, contentsItem.id)); })] }))] }));
};
exports.ContentsSeriesForm = ContentsSeriesForm;
function validateGroup(group) {
    var result = {};
    if (group.name == null || group.name.length === 0)
        result.name = { required: true };
    if (group.name && group.name.length > 255)
        result.name = { overMaxLength: true };
    result.valid = !Object.keys(result).length;
    return result;
}
function genValidationResult(result) {
    return function ValidationResult(_a) {
        var prop = _a.prop;
        var propResult = result[prop];
        if (propResult) {
            if (propResult.required)
                return (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Message, { error: true, content: i18n_1.default.required });
            if (propResult.overMaxLength)
                return (0, jsx_runtime_1.jsx)(semantic_ui_react_1.Message, { error: true, content: i18n_1.default.overMaxLength });
        }
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
    };
}
function genSetTempContentsSeriesProp(setTempGroup) {
    return function setTempGroupProp(prop) {
        return function setProp(e, _a) {
            var value = _a.value;
            setTempGroup(function (tempGroup) {
                var _a;
                return (__assign(__assign({}, tempGroup), (_a = {}, _a[prop] = value, _a)));
            });
        };
    };
}
function saveContentsSeries(isNew, temp, setContentsSeriesFetchRequest, setId, incrementErrorCount) {
    return __awaiter(this, void 0, void 0, function () {
        var id, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    id = temp.id;
                    if (!isNew) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0, api_1.createContentsSeries)(temp)];
                case 1:
                    id = _a.sent();
                    setId(id);
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, (0, api_1.updateContentsSeries)(temp)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    e_1 = _a.sent();
                    (0, sentry_1.captureException)(e_1);
                    incrementErrorCount();
                    alert("".concat(i18n_1.default.contents, "\n").concat(e_1));
                    return [3 /*break*/, 6];
                case 6:
                    setContentsSeriesFetchRequest(true);
                    return [2 /*return*/];
            }
        });
    });
}
function addContentsItem(contentsItem, setContentsItemsFetchRequest, incrementErrorCount) {
    return __awaiter(this, void 0, void 0, function () {
        var e_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0, api_1.createContentsItem)(contentsItem)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    e_2 = _a.sent();
                    (0, sentry_1.captureException)(e_2);
                    incrementErrorCount();
                    alert("".concat(i18n_1.default.contents, "\n").concat(e_2));
                    return [3 /*break*/, 3];
                case 3:
                    setContentsItemsFetchRequest(true);
                    return [2 /*return*/];
            }
        });
    });
}
function replaceContentsItem(contentsItem, setContentsItemsFetchRequest, incrementErrorCount) {
    return __awaiter(this, void 0, void 0, function () {
        var e_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0, api_1.updateContentsItem)(contentsItem)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    e_3 = _a.sent();
                    (0, sentry_1.captureException)(e_3);
                    incrementErrorCount();
                    alert("".concat(i18n_1.default.contents, "\n").concat(e_3));
                    return [3 /*break*/, 3];
                case 3:
                    setContentsItemsFetchRequest(true);
                    return [2 /*return*/];
            }
        });
    });
}
function destroyContentsItem(contentsItemId, setContentsItemsFetchRequest, incrementErrorCount) {
    return __awaiter(this, void 0, void 0, function () {
        var e_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    // eslint-disable-next-line no-restricted-globals
                    if (!confirm(i18n_1.default.deleteConfirm))
                        return [2 /*return*/];
                    return [4 /*yield*/, (0, api_1.deleteContentsItem)(contentsItemId)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    e_4 = _a.sent();
                    (0, sentry_1.captureException)(e_4);
                    incrementErrorCount();
                    alert("".concat(i18n_1.default.contents, "\n").concat(e_4));
                    return [3 /*break*/, 3];
                case 3:
                    setContentsItemsFetchRequest(true);
                    return [2 /*return*/];
            }
        });
    });
}
